export const environment = {
  production: true,
  baseUrl: 'http://api.bit.ir',
  TAILWIND_MODE: 'build',
  invalidatedKey: '6ea2fdbb-ee0b-416d-9c9f-9da85f76e338',
  domain: "https://bit.ir"
};
